import React from 'react';
import {FormDialog} from 'components/core';
import {TagsCtx} from 'components/dataProviders/tags';
import {ChannelsCtx} from 'components/dataProviders/channels';


export default function Edit({channelID, open, onClose})
{
    const tagsCtx = React.useContext(TagsCtx);
    const channelsCtx = React.useContext(ChannelsCtx);
    const [loading, setLoading] = React.useState(false);
    const [tagItems, setTagItems] = React.useState([]);

      React.useEffect(function initializeTags() {
        let tags = [];
        tagsCtx.data.active.forEach((item) => tags.push({value: item.tagID, content: item.name}));
  
        setTagItems(tags);
    }, [tagsCtx]);

    const handleClose = () => {
        if(onClose) onClose();
      };
  
      const handleConfirm = (values) => {
        setLoading(true);
        channelsCtx.funcs.update(channelID, values).then(() => {
          setLoading(false);
          handleClose();
        });
      }

    return <FormDialog
    open={open}
    onClose={handleClose}
    onConfirm={handleConfirm}
    title="Editar Canal"
    subtitle="Cambia el nombre o las etiquetas del canal"
    confirm="Guardar"
    cancel="Cancelar"
    loading={loading}
    fields={[
      {
        type: "text",
        label: "Nombre del canal",
        id: "name",
        placeholder: "",
        mandatory: true,
        value: channelsCtx.data.indexed[channelID] ? channelsCtx.data.indexed[channelID].name : ''
      },
      {
        type: "tagSelector",
        label: "Etiquetas",
        id: "tags",
        items: tagItems,
        value: channelsCtx.data.indexed[channelID] ? channelsCtx.data.indexed[channelID].tags : []
      }
    ]}
    />
}